import { combineTokens } from '@utils/css';

const tokens = combineTokens("--progress-bar", {
  filled: "0",
  dragHandleOffset: "0"
});
const wrapper = "_vcw1wmt0po";
const track = "_vcttitpbo";
const dragHandle = "_vcd17oovd8";

export { dragHandle, tokens, track, wrapper };
import "./atom.progress-bar.style.linaria.module.css";
//# sourceMappingURL=atom.progress-bar.style.js.map
